import React from 'react';

const ArrowThinBlue = () => (
    <svg width="42" height="18" viewBox="0 0 42 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 8.25H0.25V9.75H1V8.25ZM41 9L41.5051 9.5544C41.6611 9.41228 41.75 9.21102 41.75 9C41.75 8.78898 41.6611 8.58772 41.5051 8.4456L41 9ZM1 9.75H41V8.25H1V9.75ZM40.4949 8.4456L31.7144 16.4456L32.7246 17.5544L41.5051 9.5544L40.4949 8.4456ZM31.7144 1.5544L40.4949 9.5544L41.5051 8.4456L32.7246 0.445603L31.7144 1.5544Z" fill="#4395B8"/>
    </svg>
);

export default ArrowThinBlue;
